import {
  Fab,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import React, {useEffect, useState} from 'react';
import {
  getPlayerAssignments,
  postPlayerAssignment,
} from '../utils/PlayerApi';
import SaveIcon from '@mui/icons-material/Save';
import RedoIcon from '@mui/icons-material/Redo';
import {useLoading} from '../../loading-overlay/LoadingContext';
import {toast} from 'react-toastify';
import RecentPlayers from './RecentPlayers';
import PlayerAssignments from './PlayerAssignments';

export default function AssignPlayersTab() {
  const {addToLoading} = useLoading();

  const [selectedPlayerAssignmentIndex, setSelectedPlayerAssignmentIndex] = useState(-1);
  const [playerAssignments, setPlayerAssignments] = useState([]);

  async function fetchPlayerAssignments() {
    const currentPlayerAssignments = await getPlayerAssignments();
    setPlayerAssignments(currentPlayerAssignments);
    setSelectedPlayerAssignmentIndex(0);
  }

  useEffect(() => {
    addToLoading(fetchPlayerAssignments());
  }, []);

  function updateAssignedPlayerAndSelectNextAssignment(selectedPlayer) {
    const selectedAssignment = playerAssignments[selectedPlayerAssignmentIndex];
    updateAssignment(selectedAssignment, selectedPlayer.displayName, selectedPlayer.id);

    setSelectedPlayerAssignmentIndex((currentIndex) => {
      if (currentIndex + 1 < playerAssignments.length) {
        return currentIndex + 1;
      } else {
        return 0;
      }
    });
  }

  function updateAssignment(assignment, newDisplayName, newPlayerId) {
    if (!assignment.changed) {
      assignment.originalValues = {
        displayName: assignment.displayName,
        assignedPlayerId: assignment.assignedPlayerId,
      };
    }

    assignment.displayName = newDisplayName;
    assignment.assignedPlayerId = newPlayerId;
    assignment.changed = true;
  }

  const onPlayerSelected = (player) => {
    if (player !== undefined) {
      updateAssignedPlayerAndSelectNextAssignment(player);
    }
  };

  async function savePlayerAssignments() {
    const assignmentsToSave = playerAssignments
      .filter((playerAssignment) => playerAssignment.changed);
    if (assignmentsToSave.length === 0) {
      toast.info('No changes to save');
      return;
    }

    localStorage.setItem('lastAssignments', JSON.stringify(assignmentsToSave));
    await addToLoading(postPlayerAssignment(assignmentsToSave));
    playerAssignments.forEach((value) => value.changed = false);
    setPlayerAssignments([...playerAssignments]);
    toast.success('Data successfully saved');
  }

  async function redoLastAssignment() {
    const lastAssignmentJson = localStorage.getItem('lastAssignments');
    if (!lastAssignmentJson) {
      toast.info('No last assignment found');
      return;
    }
    const lastAssignments = JSON.parse(lastAssignmentJson);
    const updatedAssignments = [...playerAssignments];
    for (const lastAssignment of lastAssignments) {
      const assignmentToUpdate = updatedAssignments
        .find((playerAssignment) => playerAssignment.name === lastAssignment.name);
      if (assignmentToUpdate) {
        updateAssignment(
          assignmentToUpdate,
          lastAssignment.displayName,
          lastAssignment.assignedPlayerId,
        );
      }
    }
    setPlayerAssignments(updatedAssignments);
    toast.info('Assigned the same players as the last time assignments where saved.');
  }

  function revertAssignment(assignmentIndex) {
    const selectedAssignment = playerAssignments[assignmentIndex];
    const revertedAssignment = {...selectedAssignment};
    revertedAssignment.displayName = selectedAssignment.originalValues.displayName;
    revertedAssignment.assignedPlayerId = selectedAssignment.originalValues.assignedPlayerId;
    revertedAssignment.changed = false;

    const revertedAssignments = [...playerAssignments];
    revertedAssignments[assignmentIndex] = revertedAssignment;
    setPlayerAssignments(revertedAssignments);
  }

  return (
    <Grid container justifyContent={'center'} spacing={5}>
      <Grid item>
        <RecentPlayers onSelected={onPlayerSelected}/>
      </Grid>
      <Grid item>
        <PlayerAssignments
          playerAssignments={playerAssignments}
          selectedIndex={selectedPlayerAssignmentIndex}
          onReloadData={() => addToLoading(fetchPlayerAssignments())}
          onSelected={setSelectedPlayerAssignmentIndex}
          onRevertItem={revertAssignment}
        />
      </Grid>

      <Fab
        color="primary"
        aria-label="redo assignment"
        onClick={redoLastAssignment}
        sx={{
          margin: 0,
          top: 'auto',
          right: 20,
          bottom: 90,
          left: 'auto',
          position: 'fixed',
        }}
      >
        <RedoIcon/>
      </Fab>
      <Fab
        color="primary"
        aria-label="add"
        onClick={savePlayerAssignments}
        sx={{
          margin: 0,
          top: 'auto',
          right: 20,
          bottom: 20,
          left: 'auto',
          position: 'fixed',
        }}
      >
        <SaveIcon/>
      </Fab>
    </Grid>
  );
}
